"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _actions = require("../../../actions");
var _actionUtils = require("../../../utils/actionUtils");
function sourceToggled(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var notifyingDirector = _ref2.notifyingDirector;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, getState())) {
    dispatch((0, _actions.getSources)());
  }
}
var _default = exports["default"] = sourceToggled;